import { UIIcon } from '../../config/icons';
import { eIntentGetResponse, eIntentSetProvider, EPaymentIntent } from '../mdl/e-payment-intent';
import { UIButton } from '../ui/component/button';
import { UIDialog } from '../ui/component/dialog';
import { uiToast } from '../ui/component/toast';
import { $el } from '../ui/elements';
import { $stripe } from '../ui/payment/stripe';
import { $trustly } from '../ui/payment/trustly';
import { UIView } from '../ui/view';
import { $log } from '../y/debug';
import { $i18n, yInterpolate } from '../y/i18n';
import { TLInfinityLoader } from './widgets';

export interface ABPaymentDialogOptions {
    title?: string;
    info?: string;
}

interface ABPaymentFormCallbacks<Response> {
    finish: (response: Response) => void;
}

export class ABPaymentForm<Response> extends UIView {
    constructor(intent: EPaymentIntent, callbacks: ABPaymentFormCallbacks<Response>, dialog?: UIDialog) {
        super('div', 'l-form m-center');

        const toLoader = (intent: EPaymentIntent) => {
            this.root.style.height = this.root.clientHeight + 'px';

            this.ui_empty(new TLInfinityLoader);

            eIntentGetResponse<Response>(intent).then(response => {
                dialog && dialog.dismiss(true);
                callbacks.finish(response);
            })
        }

        const toPayment = (intent: EPaymentIntent) => {
            if(intent.provider == 'stripe') {
                const stripe_form = new $stripe.Form(intent.is_test, intent.provider_data!.client_secret!, intent.amount.value == 0, 'https://abundolive.se/giftcard?confirmation=' + intent.id);

                this.ui_empty([
                    stripe_form,
                    $el.DIV('s-medium'),
                    new UIButton({
                        title: intent.amount.value ? yInterpolate($i18n.tl.b_pay, intent.amount.value / 100, intent.amount.currency) : $i18n.tl.b_confirm, on_click: () => {
                            return stripe_form.submit().then(() => {
                                toLoader(intent)
                            }, error => {
                                uiToast(error.message);
                            });
                        }
                    })
                ]);
            } else if(intent.provider == 'trustly') {
                const trustly_form = new $trustly.Form(intent.provider_data!.url!)

                this.ui_empty([
                    trustly_form
                ]);

                trustly_form.wait().then(id => {
                    if(id != intent.id) {
                        $log('app', 'Invalid id!!!! what to do now?');
                    }
                    toLoader(intent);
                }, () => {
                    $log('app', 'failed!!!! what to do now?');
                    toButtons(intent);
                })
            } else {
                toLoader(intent);
            }
        }

        const toButtons = (intent: EPaymentIntent) => {
            if(intent.provider) {
                toPayment(intent);
            } else if(intent.supported_providers.length == 1) {
                eIntentSetProvider(intent, intent.supported_providers[0]).then(toPayment);
            } else {
                this.ui_empty();

                for(let p of intent.supported_providers) {
                    this.ui_add(new UIButton({
                        title: p == 'trustly' ? (intent.transaction_kind == 'buy_giftcard' || intent.transaction_kind == 'book' || intent.transaction_kind == 'buy_more' ? $i18n.tl.b_pay_autogiro_once : $i18n.tl.b_pay_autogiro) : $i18n.tl.b_pay_card, classes: 'ui-tint-subtle m-spaces', right_icon: UIIcon.ANGLE_RIGHT, spaces: true, on_click: () => {
                            eIntentSetProvider(intent, p).then(toPayment);
                        }
                    }))
                }
            }
        }

        toButtons(intent);
    }
}

export class ABPaymentDialog<Response> extends UIDialog {
    constructor(intent: EPaymentIntent, callbacks: ABPaymentFormCallbacks<Response>, options: ABPaymentDialogOptions) {
        super({ close: true, classes: 'm-550 m-mobile-fs' });

        this.content.ui_add([
            $el.DIV('w-block l-form m-center', [
                $el.H2('title', options.title || $i18n.tl.h_payment),
                new ABPaymentForm(intent, callbacks, this),
                options.info && $el.P('small', options.info)
            ]),
        ]);
    }
}
